(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorog-signature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ré-init sur shopify:section:load (éditeur de thème / hot-reload) */
    function initSig(root) {
      if (!root || root.dataset.vsigInit) return;
      root.dataset.vsigInit = '1';

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return; // plein statique

      var mark = root.querySelector('[data-vsig-mark]');
      var line = root.querySelector('.vorog-sig__svg--line .vorog-mono__path');
      if (!mark || !line) return;

      var lineLen = line.getTotalLength();
      line.style.strokeDasharray = lineLen;
      line.style.strokeDashoffset = lineLen;

      // Frontière V→K mesurée sur le tracé réel — même méthode que le hero
      // (une passe de ~200 appels, à l'init). Le hero porte la boîte et la
      // matrice entières ; ici seuls ces deux termes servent.
      var TX = 343.8436;                        // matrice du tracé, terme en x
      var midX = 99.2316 + 380.037 * 0.52;      // boîte du monogramme, 52 %
      var vcut = 0.57;
      (function () {
        var lastSide = null;
        for (var i = 0; i <= 200; i++) {
          var side = (line.getPointAtLength(lineLen * i / 200).x + TX) < midX ? 'V' : 'K';
          if (lastSide === 'V' && side === 'K' && i / 200 > 0.4 && i / 200 < 0.75) vcut = i / 200;
          lastSide = side;
        }
      })();

      function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
      // rythme d'une plume : départ retenu, arrivée posée — comme le hero
      function ease(t) { return 0.5 - 0.5 * Math.cos(Math.PI * t); }

      var pCur = null;
      function draw() {
        var sr = root.getBoundingClientRect();
        var mr = mark.getBoundingClientRect();
        var vh = window.innerHeight;
        var sy = window.pageYOffset;
        var maxS = document.documentElement.scrollHeight - vh;
        // Plage locale : de l'entrée de la section à la fin de course réelle,
        // bornée « marque encore à l'écran » (une borne figée se périme).
        var y0 = sr.top + sy - vh;
        var y1 = Math.min(maxS - 16, mr.bottom + sy - vh * 0.35);
        if (y1 - y0 < 240) y1 = y0 + 240;
        var target = clamp01((sy - y0) / (y1 - y0));
        if (pCur === null) pCur = target;
        pCur += (target - pCur) * 0.16;
        var busy = Math.abs(target - pCur) > 0.0008;
        if (!busy) pCur = target;
        var p = pCur;
        // Écriture : le V puis le K, deux coups de plume — comme à
        // l'ouverture. Départ à 0,15 : la section n'est pas épinglée, plus
        // tôt le premier tiers du V s'écrivait sous la ligne de flottaison
        // (mesuré : marque à l'écran seulement à p 0,25).
        var written = ease(clamp01((p - 0.15) / 0.35)) * vcut
                    + ease(clamp01((p - 0.55) / 0.30)) * (1 - vcut);
        line.style.strokeDashoffset = (lineLen * (1 - written)).toFixed(1);
        // Le plein se pose et RESTE — la fermeture ne se défait pas.
        // Pendant le posé, la même micro-pulsation de largeur que le hero
        // (±0,18 unité) : le scroll ne semble jamais figé.
        mark.style.setProperty('--vsig-f', clamp01((p - 0.87) / 0.09).toFixed(3));
        var w = 8;
        if (p > 0.87) w += Math.sin((p - 0.87) * 48) * 0.36;
        mark.style.setProperty('--vsig-sw', w.toFixed(2));
        return busy;
      }

      draw();
      if (window.VorogMotion && window.VorogMotion.register) {
        window.VorogMotion.register({
          active: function () {
            var r = root.getBoundingClientRect();
            return r.bottom > 0 && r.top < window.innerHeight;
          },
          update: draw
        });
        document.documentElement.classList.add('vsig-on');
      }
      // pas de boucle partagée : rien n'est armé, le plein statique reste
    }

    initSig(document.querySelector('[data-vorog-sig]'));
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target && e.target.querySelector ? e.target.querySelector('[data-vorog-sig]') : null;
      if (r) initSig(r);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
